import React, { useState, useEffect } from "react";
import Button from '@mui/material/Button';
import SendIcon from '@mui/icons-material/Send';
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from 'react-icons/fa';
import API_BASE_URL from '../config';
import disposableDomains from '../utils/disposableDomains';
import '../Styles/contact.css';


export default function Contact() {
  const isMobile = window.innerWidth <= 768; // ✅ ADD HERE

  useEffect(() => {
    document.title = "Contact | Outstanding Workplaces";
  }, []);

  const [form, setForm] = useState({
    firstName: '', lastName: '', role: '', email: '', mobile: '',
    typeOfCompany: '', companyName: '', hq: '', industry: '', employees: '',
    howDidYouKnow: '', consent: false
  });
  const [submitted, setSubmitted] = useState(false);
  const [emailError, setEmailError] = useState("");


  // Email validation function using disposableDomains
  const validateEmail = (email) => {
    const parts = email.split("@");
    if (parts.length !== 2) return false;
    const domain = parts[1].toLowerCase();
    return !disposableDomains.includes(domain);
  };

  const handleChange = e => {
    const { name, value, type, checked } = e.target;
    setForm(f => ({
      ...f,
      [name]: type === 'checkbox' ? checked : value
    }));

    // Real-time email validation
    if (name === "email") {
      if (!validateEmail(value)) {
        setEmailError("Please enter your work email address.");
      } else {
        setEmailError("");
      }
    }
  };

  const handleSubmit = async e => {
    e.preventDefault();
    // Final check before submit
    if (!validateEmail(form.email)) {
      setEmailError("Please enter your work email address.");
      return;
    }
    try {
      const res = await fetch(`${API_BASE_URL}/api/nominations`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form)
      });
      const data = await res.json();
      if (res.ok && data.success) {
        setSubmitted(true);
      } else {
        alert('Submission failed: ' + (data.error || 'Unknown error'));
        console.error('Submission error:', data);
      }
    } catch (err) {
      alert('Network or server error. See console for details.');
      console.error('Network/server error:', err);
    }
  };

  return (
    <section className="contact-section"  style={{
    background: "#FFFFFF",
    minHeight: isMobile ? "170vh" : "130vh", // 👈 mobile vs desktop
    padding: "15px 0"
  }} >
      <div style={{ maxWidth: 1100, margin: "0 auto", padding: "0 16px" }}>
        <h1 style={{
          textAlign: "center",
          fontSize: "2.5rem",
          fontWeight: 700,
          marginBottom: 40,
          letterSpacing: "-1px"
        }}>
          Get in Touch
        </h1>
        <div style={{
          display: "flex",  
          flexDirection: "column",
          alignItems: "center",
          gap: 40
        }}>
          <div
            style={{
              width: "100%",
              maxWidth: 750,
              margin: "0 auto",
              background: "#ffffff",
              borderRadius: 10,
              boxShadow: "0 2px 8px #0001",
              padding: 20,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              boxSizing: "border-box",
              
            }}
            className="contact-form-outer"
          >
            <style>
              {`
                /* ...existing styles... */
              `}
            </style>
            {submitted ? (
              <div style={{ textAlign: "left", minHeight: 200, display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                <h2 style={{ fontSize: "2rem", marginBottom: "1rem", color: "#0b1d51", fontWeight: 700 }}>
                  Certification Submission Received!
                </h2>
                <p style={{ fontSize: "1.15rem", color: "#222", fontWeight: 500, maxWidth: 600, marginBottom: 16 }}>
                  Thank you for taking the first step towards becoming certified with Outstanding Workplaces!
                </p>
                <p style={{ fontSize: "1.05rem", color: "#333", maxWidth: 600, marginBottom: 16 }}>
                  We're thrilled to have you on board and look forward to working together to elevate workplace excellence.
                </p>
                <p style={{ fontSize: "1.05rem", color: "#333", maxWidth: 600, marginBottom: 16 }}>
                  Our team will review your submission and details.<br />
                  You'll receive an email from us at the address you provided in the registration form with further instructions.<br />
                  We'll guide you through the next steps to achieve Outstanding Workplaces certification.
                </p>
                <h3 style={{ color: '#0b1d51', marginTop: 24, fontWeight: 700 }}>Welcome to the Journey!</h3>
                <p style={{ fontSize: '1.05rem', color: '#333', maxWidth: 600, marginBottom: 16 }}>
                  We're excited to have you as part of our community committed to creating exceptional workplaces.<br />
                  Thank you for choosing Outstanding Workplaces!
                </p>
                <p style={{ marginTop: 24, fontWeight: 500, fontSize: '1.05rem', color: '#222' }}>
                  Stay tuned for updates, and don't hesitate to reach out if you have any questions –<br />
                  <a href="mailto:support@outstandingworkplaces.co" style={{ color: '#0b1d51', textDecoration: 'none' }}>support@outstandingworkplaces.co</a> / <a href="tel:9751529398" style={{ color: '#0b1d51', textDecoration: 'none' }}>9751529398</a>
                </p>
              </div>
            ) : (
              <form className="nomination-form" onSubmit={handleSubmit}>
                <div className="form-row">
                  <div className="form-group" >
                    <label>* First Name</label>
                    <input name="firstName" type="text" placeholder="Enter your first name" value={form.firstName} onChange={handleChange} required />
                  </div>
                  <div className="form-group" >
                    <label>* Last Name</label>
                    <input name="lastName" type="text" placeholder="Enter your last name" value={form.lastName} onChange={handleChange} required />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group" >
                    <label>* Role</label>
                    <select name="role" value={form.role} onChange={handleChange} required>
                      <option value="">-Select Role-</option>
                      <option>Founder / CEO</option>
                      <option>CHRO / Vice President</option>
                      <option>Head HR</option>
                      <option>HR / Training</option>
                      <option>Marketing Team</option>
                      <option>Talent Acquisition / Recruitment</option>
                      <option>Executive Team</option>
                      <option>Other</option>
                    </select>
                  </div>
                  <div className="form-group" >
                    <label>* Work Email Address</label>
                    <input
                      name="email"
                      type="email"
                      placeholder="Enter your work email address"
                      value={form.email}
                      onChange={handleChange}
                      required
                      style={emailError ? { borderColor: "red" } : {}}
                    />
                    {emailError && (
                      <div >
                        {emailError}
                      </div>
                    )}
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group" >
                    <label>* Mobile Number</label>
                    <input name="mobile" type="text" placeholder="Enter your mobile number" value={form.mobile} onChange={handleChange} required />
                  </div>
                  <div className="form-group">
                    <label>* Type of Company</label>
                    <select name="typeOfCompany" value={form.typeOfCompany} onChange={handleChange} required>
                      <option value="">-Select-</option>
                     <option>Proprietorship</option>
<option>Partnership</option>
<option>Limited Liability Partnership (LLP)</option>
<option>Private Limited (Pvt Ltd)</option>
<option>Public Limited</option>
<option>One Person Company (OPC)</option>
<option>Corporation</option>
<option>Non-Governmental Organization (NGO)</option>
<option>Educational Institution / University</option>
<option>Others</option>
                    </select>
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group" >
                    <label>* Company Name</label>
                    <input name="companyName" type="text" placeholder="Enter your Company Name" value={form.companyName} onChange={handleChange} required />
                  </div>
                  <div className="form-group" >
                    <label>* Company's Headquarters</label>
                    <select name="hq" value={form.hq} onChange={handleChange} required>
                      <option value="">-Select -</option>
                      <option>Andhra Pradesh</option>
                      <option>Arunachal Pradesh</option>
                      <option>Assam</option>
                      <option>Bihar</option>
                      <option>Chhattisgarh</option>
                      <option>Goa</option>
                      <option>Gujarat</option>
                      <option>Haryana</option>
                      <option>Himachal Pradesh</option>
                      <option>Jharkhand</option>
                      <option>Karnataka</option>
                      <option>Kerala</option>
                      <option>Madhya Pradesh</option>
                      <option>Maharashtra</option>
                      <option>Manipur</option>
                      <option>Meghalaya</option>
                      <option>Mizoram</option>
                      <option>Nagaland</option>
                      <option>Odisha</option>
                      <option>Punjab</option>
                      <option>Rajasthan</option>
                      <option>Sikkim</option>
                      <option>Tamil Nadu</option>
                      <option>Telangana</option>
                      <option>Tripura</option>
                      <option>Uttar Pradesh</option>
                      <option>Uttarakhand</option>
                      <option>West Bengal</option>
                      <option>Andaman & Nicobar Islands</option>
                      <option>Chandigarh</option>
                      <option>Dadra & Nagar Haveli and Daman & Diu</option>
                      <option>Delhi</option>
                      <option>Lakshadweep</option>
                      <option>Puducherry</option>
                      <option>Ladakh</option>
                      <option>Jammu & Kashmir</option>
                    </select>
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group" >
                    <label>* Industry</label>
                    <select name="industry" value={form.industry} onChange={handleChange} required>
                      <option value="">-Select Industry-</option>
                      <option>Agriculture</option>
                      <option>Automotive</option>
                      <option>Banking & Financial Services (BFSI)</option>
                      <option>Chemicals & Petrochemicals</option>
                      <option>Construction & Infrastructure</option>
                      <option>Consumer Goods & FMCG</option>
                      <option>Education & Training</option>
                      <option>Energy & Utilities</option>
                      <option>Engineering & Industrial Manufacturing</option>
                      <option>Environmental Services</option>
                      <option>Food & Beverage</option>
                      <option>Government & Public Sector</option>
                      <option>Healthcare & Pharmaceuticals</option>
                      <option>Hospitality & Tourism</option>
                      <option>Information Technology (IT) & Software</option>
                      <option>Insurance</option>
                      <option>Logistics & Supply Chain</option>
                      <option>Media & Entertainment</option>
                      <option>Mining & Metals</option>
                      <option>Manufacturing & Production</option>
                      <option>Non-Profit & NGOs</option>
                      <option>Oil & Gas</option>
                      <option>Real Estate</option>
                      <option>Retail & E-commerce</option>
                      <option>Telecommunications</option>
                      <option>Textiles & Apparel</option>
                      <option>Transportation</option>
                      <option>Research & Development (R&D)</option>
                      <option>Aerospace & Defense</option>
                      <option>Consulting & Professional Services</option>
                       <option>Others</option>
                    </select>
                  </div>
                  <div className="form-group" >
                    <label>* Number of Employees</label>
                    <select name="employees" value={form.employees} onChange={handleChange} required>
                      <option value="">-Select-</option>
                      <option>10 - 20</option>
                      <option>21 - 50</option>
                      <option>51 - 100</option>
                      <option>101 - 200</option>
                      <option>501 - 1000</option>
                      <option>1001 - 3000</option>
                      <option>3001 - 5000</option>
                      <option>5001 - 10000</option>
                      <option>Above 10000</option>
                    </select>
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label>* How did you come to know about us?</label>
                    <select name="howDidYouKnow" value={form.howDidYouKnow} onChange={handleChange} required>
                      <option value="">-Select-</option>
                      <option>Google Search</option>
                      <option>Social Media</option>
                      <option>WhatsApp Group</option>
                      <option>HR Community</option>
                      <option>Referred by Others</option>
                    </select>
                  </div>
                </div>
                <div className="form-row">
                 <label style={{ display: "block", transform: "translateY(-7px)" }}>
  <input
    name="consent"
    type="checkbox"
    checked={form.consent}
    onChange={handleChange}
    required
  />
  You acknowledge that you've read and understood the{" "}
  <a href="/terms-and-conditions" rel="noopener noreferrer">
    Terms and conditions
  </a>{" "}
  and <br />
  <a href="/privacy-policy" rel="noopener noreferrer">
    Privacy policy
  </a>.*
</label>
                </div>
                <Button
  type="submit"
  variant="contained"
 sx={{
    fontWeight: 600,
    fontSize: '1.1rem',
    borderRadius: '8px',
    boxShadow: 'none',
    textTransform: 'none',
    padding: '10px 28px',
    backgroundColor: '#0b1d51',

    position: 'relative',
    top: '-10px', // 👈 move upward safely (no layout break)

    '&:hover': {
      backgroundColor: '#f28500',
    }
  }}
>
  SUBMIT
</Button>
              </form>
            )}
          </div>
           

        </div>
      </div>
      <div className="contact-info-container">

          {/* Left Content */}
          <div className="contact-info-left">
            <h2 className="contact-info-title">Contact Us</h2>

            <div className="contact-block">
              <h3 className="company-title">
                <img src="/Tracking_cnt.png" className="company-icon" alt="" />
                Outstanding Workplaces 
              </h3>

              <p>
                No 2, First Floor, Avvaiyar Street,<br/>
                Ekkattuthangal, Chennai – 600032.
              </p>

             <a
  href="https://maps.app.goo.gl/j3Nrxa3wXYpFNfZu7"
  target="_blank"
  rel="noopener noreferrer"
  className="view-map"
>
  View Map
</a>
            </div>

            <div className="contact-block">
              <h3 className="title-with-icon">
                <img src="/Dwnld_email.png" className="icon" alt="" />
                <span className="enquiry-text">For Enquiries</span>
              </h3>

              <p>Have questions about our services, partnership?</p>

              <p className="info-row">
               <img src="/mail_cnt.png" className="icon" alt="" />
                <a 
                  href="support@outstandingworkplaces.co" 
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  support@outstandingworkplaces.co
                </a>
              </p>

              <p className="info-row">
                <img src="/call_cnt.png" className="icon" alt="" />
                <a 
                  href="tel:+919787729398" 
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  +91 9751529398
                </a>
              </p>
            </div>

            

          </div>

          {/* Right Image */}
          <div className="contact-info-right">
            <img src="/Cnct_right.png" className="contact-info-image" alt="" />
          </div>

        </div>
    </section>
  );
}